export enum ContactPreference {
    NO,
    YES,
    MAYBE
}

export enum InformationSource {
    OTHER,
    MEMBER,
    SOCIAL_NETWORK,
    YOUTUBE,
    FACEBOOK,
    TV
}

export enum Profession {
    OTHER,
    TEACHER,
    DOCTOR,
    ENGINEER,
    BUSINESS,
    STUDENT
}

export enum VisitPurpose {

    OTHER,
    SERVICE,
    GOVERNMENT,
    PRAYER
}

export enum VisitorType {
    GUEST,
    PASTOR,
    STAFF,
    VIP,
    GOVT_OFFICIAL,
    PROSPECT,
    MEMBER
}

export interface VisitLog {
    id: number;
    entry_time: string;
    exit_time: string | null;
    notes: string;
    is_delete: boolean;
    check_in: string | null;
    check_out: string | null;
    purpose: number;
    visitory_type: number;
    is_member: boolean;
    require_follow_up?: boolean;
    follow_up_status?: number | null;
    visitor: Visitor | null;
    member: Member | null;
    vehicle_log: any; // You can refine if structure known
    vehicles?: Array<{
        id?: number;
        reg_no: string;
        type?: string;
        make?: string;
        color?: string;
        is_request_send?: boolean;
        visitor?: boolean;
    }>;
    to_meet: Member[];
    appartments: any[]; // refine later if structure known
}

// export interface VisitLogCreate {
//     id: number;
//     entry_time: string;
//     exit_time: string | null;
//     notes: string;
//     is_delete: boolean;
//     check_in: string | null;
//     check_out: string | null;
//     purpose: number;
//     visitory_type: number;
//     is_member: boolean;
//     visitor: VisitorCreate | null;
//     member_id?: number
//     vehicle_log: any; // You can refine if structure known
//     vehicles: any[];  // refine later if vehicle details exist
//     to_meet_user_ids: number[];
//     appartments: any[]; // refine later if structure known
// }

export interface Visitor {
    phones?: string[] | null;
    phone?: string | null;
    id: number;
    visitor_full_name: string;
    is_prospect: boolean;
    emails?: string[];
    email?: string | null;
    designation_profession: number;
    other_designation_profession?: string | null;
    source_of_information: number;
    other_source_specify: string | null;
    current_church: string | null;
    current_church_pastors: string | string[] | null;
    current_church_address: string | null;
    contact_preference: number;
    prayer_request: string | null;
    is_referrer_member: boolean;
    referrer_full_name: string | null;
    referrer_address: string | null;
    referrer_phone: string | null;
    referrer_member_user_id?: number | null;
    referrer_member?: Member | null;
}


// export interface VisitorCreate {
//     phones: string[] | null;
//     id: number;
//     visitor_full_name: string;
//     is_prospect: boolean;
//     emails: string[];
//     designation_profession: number;
//     source_of_information: number;
//     other_source_specify: string | null;
//     current_church: string | null;
//     current_church_pastors: string | null;
//     current_church_address: string | null;
//     contact_preference: number;
//     prayer_request: string | null;
//     is_referrer_member: boolean;
//     referrer_full_name: string | null;
//     referrer_address: string | null;
//     referrer_phone: string | null;
// }

export interface Member {
    id: number;
    name: string;
    image_path: string | null;
    phone: string | null;
    is_whatsapp_enabled: boolean;
    address: string | null;
    is_visitor: boolean;
    member_type: string | null; // "employee" | "member" | null
    is_leader: boolean;
    is_delete: boolean;
    is_request_send: boolean;
    is_currently_married: boolean;
    has_never_married: boolean;
    date_of_birth: string | null;
    baptism_date: string | null;
    first_communion_date: string | null;
    profile: string | null;
}

export interface CreateVisitorDto {
    visitor_full_name: string;
    designation_profession: number;
    other_designation_profession?: string;
    source_of_information: number;
    other_source_specify?: string;
    current_church?: string;
    current_church_pastor: string;
    contact_preference?: number;
    prayer_request?: string;
    is_referrer_member: boolean;
    referrer_full_name?: string;
    referrer_address?: string;
    referrer_phone?: string;
    referrer_member_user_id?: number;
    phone_numbers?: string[];
    email_addresses?: string[];
}

export interface CheckVisitorDto {
    name?: string;
    phone?: string;
}

// Visit Log Management DTOs
export interface CreateVisitLogDto {
    // Required fields
    purpose: number;                    // 0=OTHER, 1=SERVICE, 2=GOVERNMENT, 3=PRAYER
    visitor_type: number;              // 0=GUEST, 1=PASTOR, 2=STAFF, 3=VIP, 4=GOVT_OFFICIAL, 5=PROSPECT, 6=MEMBER
    
    // Optional fields
    notes?: string;
    checkin_time?: string | Date;       // ISO date string or Date object
    checkout_time?: string | Date;      // ISO date string or Date object
    entry_time?: string | Date;         // Alias for checkin_time
    exit_time?: string | Date;          // Alias for checkout_time
    require_follow_up?: boolean;        // Default: false
    follow_up_status?: number;          // FollowUpStatus enum
    
    // Member/Visitor Selection (one of these)
    user_id?: number;                   // Member ID
    member_id?: number;                 // Alias for user_id
    visitor_id?: number;                // Existing visitor ID
    
    // Relationships
    to_meet_user_ids?: number[];        // Array of user IDs to meet
    apartment_ids?: number[];           // Array of apartment IDs
    vehicle_log_id?: number;            // Existing vehicle log ID
    
    // Vehicles Array
    vehicles?: Array<{
        reg_no: string;                 // Required
        type?: string;                  // Car, Bike, Truck, etc.
        make?: string;
        color?: string;
    }>;
    
    // New Visitor Data (if creating new visitor)
    visitor?: CreateVisitorDto;
}

export interface LinkVisitVehicleDto {
    visit_log_id: number;
    vehicle_log_id: number;
}

export type FollowUpDto = {
    id: number;
    status: number;
    contact_mode: number
    contacted_date: string; // ISO datetime
    next_proposed_contact_date: string; // ISO datetime
    conversion_date: string; // ISO datetime
    notes: string;
    visitor?: Visitor
}

export interface CreateFollowUpDto {
    visitor_id: number;
    status: number;
    contact_mode: number;
    contacted_date?: Date;
    next_proposed_contact_date?: Date;
    conversion_date?: Date;
    notes?: string;
}

export enum FollowUpStatus {
    VISITED = 0,
    COMPLETED = 1,
    RESCHEDULED = 2,
    NO_ANSWER = 3,
    UNREACHABLE = 4,
    CANCELLED = 5,
    LEAD = 6,
    CONVERTED = 7
}
export interface DashboardStats {
    followUpsThisMonth: number;
    followUpsLastMonth: number;
    followUpsChangePercentage: number;
    pendingFollowUpsCount: number;
    pendingFollowUpsChange: number;
    completedFollowUpsThisMonth: number;
    completedFollowUpsLastMonth: number;
    completedFollowUpsChangePercentage: number;
    convertedFollowUpsThisMonth: number;
    convertedFollowUpsLastMonth: number;
    conversionRateThisMonth: number;
    conversionRateLastMonth: number;
    conversionRateChange: number;
    visitsThisMonth: number;
    visitsLastMonth: number;
    visitsChangePercentage: number;

}